import { useResolution886Report } from '@/context/Resolution886Report';
import { useGetGeneralComment } from './useGetGeneralComment';
import { useGetInitialComment } from './useGetInitialComment';

export const useGetComment = () => {
	const { selectedReviewId } = useResolution886Report();

	const isGeneralVersion = selectedReviewId === 'general';

	const { comment: generalComment } = useGetGeneralComment();
	const { comment: initialComment } = useGetInitialComment();

	const comment = isGeneralVersion ? generalComment : initialComment;

	return { comment };
};
